import { useTranslation } from '@crehana/i18n';
import { ATS_PUBLIC_CAREER_SITE } from './constants';
import type { TKeys } from './types';

export const useTranslationPublicCareerSite = () => {
  return useTranslation<TKeys>(ATS_PUBLIC_CAREER_SITE);
};
